import * as React from 'react';
import DOMPurify from 'dompurify';

// Preserve target="_blank" on links from legacy rich-text content, but force a safe rel
// on any new-tab link so re-allowing target cannot enable reverse tabnabbing.
// Register once: guard on the DOMPurify singleton (not a module-local flag, which would
// reset) so webpack HMR / Jest re-evaluating this module cannot stack the hook.
const purifier = DOMPurify as typeof DOMPurify & { __relNoopenerHookAdded?: boolean };
if (!purifier.__relNoopenerHookAdded) {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  purifier.__relNoopenerHookAdded = true;
}

const renderSanitizedContent = (val: string, className?: string): JSX.Element => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(val, { ADD_ATTR: ['target'] }) }}
    />
  );
};

export default renderSanitizedContent;
